import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import ErrorMain from './ErrorMain';
import Footer from '../../components/Footer';

const Error = () => {
  return (
    <>
      <HeaderSeven />

      <ErrorMain />

      <Footer />
    </>
  );
};

export default Error;
